module.exports = __webpack_public_path__ + "assets/img/beian.d0289dc0.png";